import React from 'react';
import {connect} from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
//Icon
/*import iconMaping from '../../../../utils/IconMaping.js';*/
// Component 
import AllAssetList from '../../../../asset/simple_asset/helper/component/AllAsset/AllAssetList.js';

// ==== Overide home css
import '../../../assets/custome/css/home.css';

class SimpleAssetScreen extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        activeTab: 1,
        firstTimeLoad: {
          1 : true
        }
      }

      this.toggleTab = this.toggleTab.bind(this);
    }

    toggleTab(tab) {
      if(this.state.activeTab !== tab) {
        this.setState({
          activeTab: tab,
          firstTimeLoad: {
            ...this.state.firstTimeLoad,
            [tab]: true
          }
        })
      }
    }

    RenderComponent(cluster) {
      return(
        <AllAssetList Cluster={cluster} UserReducer={this.props.UserReducer} {...this.props}></AllAssetList>
      )
    }

    render() {
      const {activeTab, firstTimeLoad} = this.state

      return (
        <div className="animated fadeIn">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <Nav tabs>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === 1 })} onClick={() => { this.toggleTab(1); }} >
                    <i></i> All Assets/Tools &nbsp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === 2 })} onClick={() => { this.toggleTab(2); }} >
                    <i></i> Idle / Available &nbsp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === 3 })} onClick={() => { this.toggleTab(3); }} >
                    <i></i> Not Available &nbsp;
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={this.state.activeTab}>
                {/* Tab 1 */}
                <TabPane tabId={1} className="">
                  <div className="card no-border">
                    {firstTimeLoad[1] && this.RenderComponent('all')}
                  </div>
                </TabPane>

                {/*  Tab 2 */}
                <TabPane tabId={2}>
                  <div className="card no-border">
                    {firstTimeLoad[2] && this.RenderComponent('idle')}
                  </div>
                </TabPane>

                {/* Tab 3 */}
                <TabPane tabId={3}>
                  <div className="card no-border">
                    {firstTimeLoad[3] && this.RenderComponent('unavailable')}
                  </div>
                </TabPane>
              </TabContent>

            </div>

          </div>
        </div>
      );
    }
}
    
const mapStateToProps = (state) => {
  return {
      UserReducer     : state.UserReducer,
  }
}


export default connect(mapStateToProps)(SimpleAssetScreen);


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/asset/simple_asset.js